import React from 'react';
import { Checkbox, Form } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from 'react-intl';

import styles from './styles.module.scss';

export function PaymentDetailsSectionHeader(): React.ReactElement {
  const intl = useIntl();
  const paymentPlan = Form.useWatch('paymentPlan');

  if (paymentPlan !== 'full') {
    return (
      <div className={styles.header}>
        <h2 className={styles.title}>
          {intl.formatMessage({ id: 'certificates.payment.detailsTitle' })}
        </h2>
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <h2 className={styles.title}>
        {intl.formatMessage({ id: 'certificates.payment.detailsTitle' })}
      </h2>
      <div className={styles.splitRow}>
        <Form.Item name="splitPayInFull" valuePropName="checked" className={styles.checkboxItem}>
          <Checkbox className={styles.checkbox}>
            {intl.formatMessage({ id: 'certificates.payment.splitPayment' })}
          </Checkbox>
        </Form.Item>
        <FontAwesomeIcon icon={faCircleInfo} className={styles.infoIcon} aria-hidden />
      </div>
    </div>
  );
}
